import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    error: null,
    user: null, // Placeholder for user info
    preferences: {
        theme: 'system', // 'light', 'dark', 'system'
    },
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        updatePreferences: (state, action) => {
            state.preferences = { ...state.preferences, ...action.payload };
        },
        logout: (state) => {
            state.user = null;
            state.error = null;
            state.isLoading = false;
        },
    },
});

export const { setLoading, setError, setUser, updatePreferences, logout } = appSlice.actions;

// Selectors
export const selectIsLoading = (state) => state.app.isLoading;
export const selectError = (state) => state.app.error;
export const selectUser = (state) => state.app.user;
export const selectPreferences = (state) => state.app.preferences;

export default appSlice.reducer;
